<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card>
      <v-row class="pt-3 pl-1 pr-1">
        <v-col cols="2.5">
          <v-menu
            v-model="pagination.startMenu"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                readonly
                v-model="pagination.startDate"
                label="Tanggal Awal"
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pagination.startDate"
              @input="onDateChange('start')"
              locale="id"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2.5">
          <v-menu
            v-model="pagination.endMenu"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="pagination.endDate"
                label="Tanggal Akhir"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pagination.endDate"
              @input="onDateChange"
              locale="id"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="auto">
          <v-autocomplete
            item-text="mst_site_name"
            item-value="mst_site_id"
            :items="siteOptions"
            v-model="selectedSiteId"
            @change="updateQuery('siteId', $event)"
            label="Lokasi Kerja"
            dense
            outlined
          ></v-autocomplete>
        </v-col>

        <v-col cols="auto">
          <v-autocomplete
            item-text="status_Os"
            item-value="status_name"
            :items="statusOsOptions"
            v-model="selectedstatusOs"
            @change="updateQuery('statusOs', $event)"
            label="Status Karyawan"
            dense
            outlined
          ></v-autocomplete>
        </v-col>

        <v-col cols="auto">
          <v-btn color="primary" @click="exportToExcel"> Download </v-btn>
        </v-col>
        <v-col cols="2.5">
          <v-text-field
            v-model="pagination.search"
            label="Search"
            append-icon="mdi-magnify"
            dense
            hide-details
            class="search-input"
            style="max-width: 250px"
            outlined
            @input="debouncedSearch"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            mobile-breakpoint="0"
            fixed-header
            dense
            class="elevation-5"
            :headers="tableHeaders"
            :items="suggestionsList"
            :items-per-page.sync="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :sort-by="pagination.sortBy"
            :sort-desc="pagination.sortDesc"
            :loading="isLoading"
            :server-items-length="totalSuggestions"
            item-key="id"
            @update:page="updateQuery('page', $event)"
            @update:items-per-page="updateQuery('itemsPerPage', $event)"
            @update:sort-by="updateQuery('sortBy', $event)"
            @update:sort-desc="updateQuery('sortDesc', $event)"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    {{ item.created_on }}
                  </td>
                  <td>
                    <div class="small-font">
                      {{ item.created_by_name }}
                    </div>
                    <div class="small-font">
                      {{ item.mst_employee_nik }}
                    </div>
                  </td>

                  <td>
                    {{ item.mst_position_name }}
                  </td>
                  <td>
                    {{ item.mst_division_name }}
                  </td>
                  <td>
                    {{ item.atasan }}
                  </td>
                  <td>{{ item.title }}</td>

                  <td>
                    <v-btn
                      color="white"
                      small
                      @click="fetchImplementDetail(item.implement_id, '1')"
                    >
                      {{ item.total_score }}
                    </v-btn>
                  </td>
                  <!-- <td>
                    <div class="small-font">
                      {{ item.created_by_name }}
                    </div>
                    <div class="small-font">
                      {{ item.created_on }}
                    </div>
                  </td> -->
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <!-- implement detail -->
    <v-dialog v-model="isDialogOpenDetail" max-width="500px">
      <v-card>
        <v-card-title class="headline">List Detail Score</v-card-title>
        <v-data-table
          mobile-breakpoint="0"
          :headers="tableHeadersDetail"
          :items="implementListDetail"
          class="elevation-1"
        >
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import exceljs from "exceljs";
import { saveAs } from "file-saver";
import { getLast30Days, dateFormatDmy } from "@/utils/date";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      statusOsOptions: [
        { status_Os: "All", status_name: "all" },
        {
          status_Os: "Outsourcing",
          status_name: "1",
        },
        {
          status_Os: "Non Outsourcing",
          status_name: "0",
        },
      ],
      implementListDetail: [],
      isDialogOpenDetail: false,
      siteOptions: [],
      selectedSiteId: null,
      selectedstatusOs: "all",
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      tableHeaders: [
        { text: "Tanggal", align: "center", value: "id" },
        { text: "Nama", align: "center", value: "employee_name" },
        { text: "Jabatan", align: "center", value: "jabatan" },
        { text: "Department", align: "center", value: "department" },
        { text: "Atasan", align: "center", value: "atasan" },
        { text: "Judul", align: "center", value: "title" },
        { text: "Score", align: "center", value: "score" },
        // { text: "Dibuat Oleh", align: "center", value: "id" },
      ],
      tableHeadersDetail: [
        { text: "Name", align: "center", value: "criteria_score_name" },
        { text: "Score", align: "center", value: "score" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        startMenu: false,
        endMenu: false,
        startDate: getLast30Days().start,
        endDate: getLast30Days().end,
        search: "",
        siteId: null,
        statusOs: "all",
        secuenceScore: "1",
      },
      totalSuggestions: 0,
      suggestionsList: [],
      isLoading: false,
      isDialogOpen: false,
      pathDocumentList: [],
      exportColumns: [
        { key: "created_on", label: "Tanggal" },
        { key: "created_by_name_and_nik", label: "Nik" },
        { key: "mst_position_name", label: "Jabatan" },
        { key: "mst_division_name", label: "Department" },
        { key: "atasan", label: "Atasan" },
        { key: "title", label: "Judul Idea" },
        {
          key: "score_materi_idea",
          label:
            "Materi Idea (Kesesuaian Idea, Latar Belakang, dan Solusi Masalah)",
        },
        // {
        //   key: "benefit",
        //   label: "Potensi Value",
        // },
        {
          key: "score_potensial_value",
          label:
            "Potensial Value (Penghematan Biaya atau Peningkatan Produktivitas)",
        },
        { key: "total_score_sequence_1", label: "Total Score" },
      ],
    };
  },
  methods: {
    async fetchImplementDetail(implement_id, secuence_score) {
      await api
        .get(
          `/implements/detail?implementId=${implement_id}&sequenceScore=${secuence_score}`
        )
        .then(({ data }) => {
          this.implementListDetail = data.data;
          // console.log(this.implementListDetail);
          this.isDialogOpenDetail = true;
        })
        .catch((error) => {
          console.error("Error fetching criteria score:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchSites() {
      api
        .get("/sites?corporateId=2")
        .then(({ data }) => {
          this.siteOptions = data.data.data;
          this.siteOptions.unshift({
            mst_site_id: "all",
            mst_site_name: "All",
          });
          this.selectedSiteId = "all";
        })
        .catch((error) => {
          console.error("Error fetching sites:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    async exportToExcel() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: 1,
        limit: -1,
        search: "",
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: true,
        siteId: this.selectedSiteId || query.siteId || "all",
        statusOs: query.statusOs || this.pagination.statusOs || "all",
        sequenceScore: 1,
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/report/assessment", { params })
        .then(({ data }) => {
          const dataExcel = data.data.data;

          // Buat workbook dan worksheet
          const workbook = new exceljs.Workbook();
          const worksheet = workbook.addWorksheet("sheet 1");

          // Tambahkan header ke worksheet
          const headerRow = this.exportColumns.map((col) => col.label);
          worksheet.addRow(headerRow);

          // Tambahkan data ke worksheet
          dataExcel.forEach((item) => {
            worksheet.addRow(this.exportColumns.map((col) => item[col.key]));
          });

          // Styling header (Bold + Background Color + Center)
          worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFF00" }, // Kuning
            };
          });

          // Styling semua sel agar center
          worksheet.eachRow((row) => {
            row.eachCell((cell) => {
              cell.alignment = { horizontal: "center", vertical: "middle" };
            });
          });

          // Auto width untuk setiap kolom
          worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
              maxLength = Math.max(
                maxLength,
                cell.value ? cell.value.toString().length : 10
              );
            });
            column.width = maxLength + 2; // Tambahkan padding
          });

          // Simpan file Excel
          workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(
              blob,
              `Report_penilaian_implementasi_(${dateFormatDmy(
                this.pagination.startDate
              )}_sampai_${dateFormatDmy(this.pagination.endDate)}).xlsx`
            );
          });
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async fetchReportAssessment() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        siteId: this.selectedSiteId || query.siteId || "all",
        statusOs: query.statusOs || this.pagination.statusOs || "all",
        sequenceScore: 1,
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/report/assessment", { params })
        .then(({ data }) => {
          // console.log(data);
          this.suggestionsList = data.data.data;
          this.totalSuggestions = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
      this.pagination.siteId = query.siteId || "all";
      this.pagination.statusOs = query.statusOs || "all";
    },
    updateQuery(key, value) {
      // console.log(key);
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },
  },
  watch: {
    pagination: {
      handler: "fetchReportAssessment",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  mounted() {
    store.commit("setTitle", "Penilaian Idea");
    this.fetchSites();
    this.fetchReportAssessment();
    this.updatePagination(this.$route.query);
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(3),
td:nth-child(4),
td:nth-child(5),
td:nth-child(6) td:nth-child(7) td:nth-child(8) td:nth-child(9) {
  text-align: center;
}
</style>
